<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div>
        <div class="bizcomp-risk-header">
            <div class="risk-header-title">风险测评</div>
            <div v-if="risksLoaded" class="risk-header-text">
                <template v-if="isReRiskAssessment">
                    以下为您上次测评的回答（共{{
                        riskQuestions.length
                    }}题），重新选择即可修改，提交后完成重新测评
                </template>
                <template v-else>
                    根据《证券期货投资者适当性管理办法》投资前请填写风险测评问卷
                </template>
            </div>
        </div>
        <div class="comp-risk-ques">
            <el-row class="risk-test">
                <el-col
                    v-if="risksLoaded"
                    class="risk-ques"
                    :class="{ 'risk-ques--flat': isReRiskAssessment }"
                    :span="24"
                >
                    <template v-if="!isReRiskAssessment">
                        <div class="risk-flat-layout">
                            <div class="risk-flat-main">
                                <div class="risk-header">
                                    <div class="ques-tit">
                                        <span class="ques-tit__progress">
                                            <span class="ques-tit__current">{{ index }}</span>
                                            <span class="ques-tit__total">
                                                /{{ riskQuestions.length }}
                                            </span>
                                        </span>
                                        <span
                                            class="ques-multi"
                                            :class="{
                                                'ques-multi--multi': doQuestion.multselect === '1'
                                            }"
                                        >
                                            {{ doQuestion.multselect === "1" ? "多选" : "单选" }}
                                        </span>
                                        <span class="ques-text">
                                            {{ doQuestion.questionname }}
                                        </span>
                                    </div>
                                    <div class="ques-box">
                                        <div class="ques-list">
                                            <el-radio-group
                                                v-if="doQuestion.multselect === '0'"
                                                v-model="answer"
                                            >
                                                <el-radio
                                                    v-for="(an, _x) in doQuestion.resultList"
                                                    :key="_x"
                                                    :label="an.result"
                                                    class="color-666"
                                                >
                                                    {{
                                                        /[a-zA-Z]+$/.test(
                                                            an.resultcontent.substr(0, 2)
                                                        )
                                                            ? an.resultcontent
                                                            : an.result + ". " + an.resultcontent
                                                    }}
                                                </el-radio>
                                            </el-radio-group>
                                            <el-checkbox-group
                                                v-if="doQuestion.multselect === '1'"
                                                v-model="answerArr"
                                            >
                                                <el-checkbox
                                                    v-for="(an, _y) in doQuestion.resultList"
                                                    :key="_y"
                                                    :label="an.result"
                                                    class="color-666"
                                                >
                                                    {{
                                                        /[a-zA-Z]+$/.test(
                                                            an.resultcontent.substr(0, 2)
                                                        )
                                                            ? an.resultcontent
                                                            : an.result + ". " + an.resultcontent
                                                    }}
                                                </el-checkbox>
                                            </el-checkbox-group>
                                        </div>
                                        <el-row class="ques-next">
                                            <el-button
                                                class="btn-prev"
                                                :disabled="index === 1"
                                                v-on:click="questionRefresh(index - 1)"
                                            >
                                                上一题
                                            </el-button>
                                            <el-button
                                                class="btn-next"
                                                :disabled="
                                                    !isAnswered || index === riskQuestions.length
                                                "
                                                v-on:click="questionRefresh(index + 1)"
                                            >
                                                下一题
                                            </el-button>
                                        </el-row>
                                    </div>
                                </div>
                            </div>
                            <aside
                                v-if="riskQuestions.length > 0"
                                class="answer-card-sidebar"
                                aria-label="答题卡"
                            >
                                <div class="answer-card-panel">
                                    <div class="answer-card-panel__title">答题卡</div>
                                    <div class="answer-card-panel__grid">
                                        <button
                                            v-for="(list, _z) in riskQuestions"
                                            :key="'first-card-' + _z"
                                            type="button"
                                            :class="[
                                                'answer-card-panel__cell',
                                                {
                                                    'answer-card-panel__cell--unanswered':
                                                        answerCardShowRedBorder(list)
                                                }
                                            ]"
                                            v-on:click="goToQuestion(_z + 1)"
                                        >
                                            <span class="answer-card-panel__cell-no">
                                                {{ _z + 1 }}、
                                            </span>
                                            <span class="answer-card-panel__cell-ans">
                                                {{ answerCardKeyDisplay(list) }}
                                            </span>
                                        </button>
                                    </div>
                                    <el-button
                                        class="answer-card-panel__submit"
                                        native-type="button"
                                        v-on:click="submitForm()"
                                    >
                                        提交问卷
                                    </el-button>
                                </div>
                            </aside>
                        </div>
                    </template>
                    <template v-else>
                        <div class="risk-flat-layout">
                            <div class="risk-flat-main">
                                <div class="risk-flat-list">
                                    <div
                                        v-for="(q, qi) in riskQuestions"
                                        :id="'risk-q-' + (qi + 1)"
                                        :key="q.questioncode || 'q-' + qi"
                                        class="risk-flat-item"
                                    >
                                        <div class="ques-tit">
                                            <span class="ques-tit__progress">
                                                <span class="ques-tit__current">{{ qi + 1 }}</span>
                                                <span class="ques-tit__total">
                                                    /{{ riskQuestions.length }}
                                                </span>
                                            </span>
                                            <span
                                                class="ques-multi"
                                                :class="{
                                                    'ques-multi--multi': q.multselect === '1'
                                                }"
                                            >
                                                {{ q.multselect === "1" ? "多选" : "单选" }}
                                            </span>
                                            <span class="ques-text">
                                                {{ q.questionname }}
                                            </span>
                                        </div>
                                        <div class="ques-box">
                                            <div class="ques-list">
                                                <el-radio-group
                                                    v-if="q.multselect === '0'"
                                                    v-model="q.key"
                                                >
                                                    <el-radio
                                                        v-for="(an, _x) in q.resultList"
                                                        :key="_x"
                                                        :label="an.result"
                                                        class="color-666"
                                                    >
                                                        {{
                                                            /[a-zA-Z]+$/.test(
                                                                an.resultcontent.substr(0, 2)
                                                            )
                                                                ? an.resultcontent
                                                                : an.result +
                                                                  ". " +
                                                                  an.resultcontent
                                                        }}
                                                    </el-radio>
                                                </el-radio-group>
                                                <el-checkbox-group
                                                    v-if="q.multselect === '1'"
                                                    :value="flatMultiAnswer(qi)"
                                                    v-on:input="setFlatMultiAnswer(qi, $event)"
                                                >
                                                    <el-checkbox
                                                        v-for="(an, _y) in q.resultList"
                                                        :key="_y"
                                                        :label="an.result"
                                                        class="color-666"
                                                    >
                                                        {{
                                                            /[a-zA-Z]+$/.test(
                                                                an.resultcontent.substr(0, 2)
                                                            )
                                                                ? an.resultcontent
                                                                : an.result +
                                                                  ". " +
                                                                  an.resultcontent
                                                        }}
                                                    </el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <aside
                                v-if="riskQuestions.length > 0"
                                class="answer-card-sidebar"
                                aria-label="答题卡"
                            >
                                <div class="answer-card-panel">
                                    <div class="answer-card-panel__title">答题卡</div>
                                    <div class="answer-card-panel__grid">
                                        <button
                                            v-for="(list, _z) in riskQuestions"
                                            :key="'card-' + _z"
                                            type="button"
                                            :class="[
                                                'answer-card-panel__cell',
                                                {
                                                    'answer-card-panel__cell--unanswered':
                                                        answerCardShowRedBorder(list)
                                                }
                                            ]"
                                            v-on:click="goToQuestion(_z + 1)"
                                        >
                                            <span class="answer-card-panel__cell-no">
                                                {{ _z + 1 }}、
                                            </span>
                                            <span class="answer-card-panel__cell-ans">
                                                {{ answerCardKeyDisplay(list) }}
                                            </span>
                                        </button>
                                    </div>
                                    <el-button
                                        class="answer-card-panel__submit"
                                        native-type="button"
                                        v-on:click="submitForm()"
                                    >
                                        提交问卷
                                    </el-button>
                                </div>
                            </aside>
                        </div>
                    </template>
                    <!-- <div class="agree-content">
                    <el-checkbox v-model="checked">
                    </el-checkbox>
                    <span>本人已仔细阅读贵司的<a class="notice-read" v-on:click.prevent="read()">《投资者类型及风险匹配告知书》</a>，已充分知晓并理解贵司对本人的风险承受能力评估及产品等级匹配结果，本人对此没有异议。
                        <br />本人承诺，将及时、如实地向贵司告知本人的重大信息变更。
                    </span>
                </div> -->
                </el-col>
            </el-row>

            <el-dialog
                title="提示"
                :visible.sync="tpasswdDialogVisible"
                class="prop info-tips"
                width="480px"
            >
                <div class="investor-tips">
                    <div class="prompt-info">
                        <p>
                            <i class="el-icon-warning" aria-hidden="true" />
                            <span>普通投资者转专业投资需要密码校验</span>
                        </p>
                    </div>
                    <el-form
                        ref="ruleForm"
                        class="two-cols-form"
                        :model="ruleForm"
                        :rules="rules"
                        label-width="37px"
                        size="small"
                    >
                        <el-form-item label="" prop="tpasswd">
                            <el-input
                                v-model="ruleForm.tpasswd"
                                type="password"
                                :maxlength="20"
                                placeholder="请输入交易密码"
                            />
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button v-on:click="tpasswdDialogVisible = false">返回</el-button>
                    <el-button type="primary" v-on:click="cancelConfirm">确定</el-button>
                </div>
            </el-dialog>
            <el-dialog
                :title="(data.risk ? '风险' : '知识') + '评测提示'"
                :visible.sync="dialogVisible"
                class="prop"
                width="420px"
            >
                <div class="info-box">
                    <el-alert :title="msg" type="warning" show-icon :closable="false" />
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button
                        v-if="passflag === '0'"
                        v-on:click="$router.push({ name: 'acctManager' })"
                    >
                        信息中心
                    </el-button>
                    <el-button type="primary" v-on:click="dialogVisible = false">
                        {{ btnMsg }}
                    </el-button>
                </div>
            </el-dialog>
            <el-dialog
                title="投资者类型及风险匹配告知书"
                :visible.sync="noticeDialogVisible"
                :fullscreen="true"
            >
                <div>
                    尊敬的投资者：
                    <br />
                    <br />
                    &emsp;&emsp;公开募集证券投资基金或私募资产管理计划（以下统称“产品”）是一种长期投资工具，其主要功能是分散投资，降低投资单一证券所带来的个别风险。产品不同于银行储蓄、国债等能够提供固定收益预期的金融工具，其投资运作过程中可能会面临各种风险，如市场风险、信用风险、流动性风险等，因此投资运作既可能产生收益，也可能产生损失（本金亏损或超过原始本金损失）。一般来说，产品的收益预期越高，投资者承担的风险也越大。由于与产品有关的文本（如产品合同、产品说明书/招募说明书（更新）、公告等）除明确产品投资范围、投资限制等还可能存在解除合同等限制性条款或对投资者行使权力有相关要求。因此，敬请投资者投资产品前认真阅读拟投资产品的产品合同、产品说明书/招募说明书、公告等与产品有关的文本，充分了解投资者的权利、义务以及该产品的风险收益特征，根据自身投资目的、风险偏好、投资经验及风险承受能力审慎选择适合自己的产品。
                    <br />
                    &emsp;&emsp;产品投资过程中除面临上述风险外，对于开放式或定期开放式产品，其运营过程中还会面临特有的巨额赎回风险，即当单个交易日产品的净赎回申请超过产品总份额一定比例时，将无法及时满足所有投资者的赎回申请。敬请投资者根据其投资期限、资产状况等判断此类产品是否与自己的风险承受能力相适应。此外，管理人业务或财务状况的变化，也可能对投资运作产生不利影响，从而使投资者承受因此产生的投资损失。敬请投资者审慎选择管理人，避免因管理人原因而影响自身合理判断。
                    <br />
                    &emsp;&emsp;本公司坚持投资者利益优先原则，在销售产品的过程中将基于投资者的不同风险承受能力以及产品的不同风险等级等因素，提出明确的适当性匹配意见。本公司的适当性匹配意见不表明对产品的风险和收益做出实质性判断或者保证。本公司提醒投资者产品投资的“卖者尽责，买者自负”原则，在做出投资决策后，产品运营状况与产品净值变化引致的投资风险，由投资者自行负担。
                    <br />
                    &emsp;&emsp;本风险告知函的揭示事项仅为列举性质，未能详尽列明投资者投资产品所面临的全部风险和可能导致投资者资产损失的所有因素。投资者应当认真阅读《基金合同》、《招募说明书》、《产品资料概要》或《私募资产管理合同》、《私募资产管理计划说明书》等法律文件，充分了解产品情况及风险收益特征，听取本公司适当性匹配意见的基础上，请投资者根据自身风险承受能力审慎决策，独立承担投资风险。
                    <br />
                    &emsp;&emsp;本公司作为管理人承诺以诚实信用、勤勉尽责的原则管理和运用产品资产，但不保证产品一定盈利，也不保证最低收益。产品的过往业绩及其净值高低并不预示其未来业绩表现。
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" v-on:click="makesureSubmit()">
                        我已阅读并知晓
                    </el-button>
                </div>
            </el-dialog>
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
        <risk-confirm-dialog
            :risk-level="predictLevel"
            :lowriskflag="predictLowriskflag"
            :visible="resultConfirmDialogVisible"
            v-on:confirm="resultConfirm"
            v-on:cancel="resultCancel"
        ></risk-confirm-dialog>
    </div>
</template>
<script>
import userApi from "@/api/user";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import RiskConfirmDialog from "@/bizcomponents/acctManager/riskConfirmDialog.vue";

export default {
    name: "RiskQues",
    components: {
        RiskConfirmDialog,
        footerQuestions
    },
    props: {
        data: {
            type: Object,
            default: function () {
                return {
                    risk: true,
                    url: "risk"
                };
            }
        },
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            agree: "",
            answer: "",
            answerArr: [],
            btnMsg: "",
            index: 1,
            query: null, // 定时器对象
            riskQuestions: [],
            doQuestion: {},
            msg: "",
            passflag: "",
            checked: true,
            noticeDialogVisible: false,
            // 密码校验
            ruleForm: {
                tpasswd: ""
            },
            rules: {
                tpasswd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            tpasswdDialogVisible: false,
            warningHtml: "",
            commonQuestion: [],
            firstriskdayflag: "",
            assettype: "",
            resultConfirmDialogVisible: false,
            predictLevel: "",
            predictLowriskflag: "",
            needResultConfirm: false,
            /** 初次风测：用户点击「提交问卷」且存在未答题后，答题卡才对空题标红 */
            firstRiskAnswerCardShowRed: false,
            /** getRisks 返回的题目中是否存在有效的历史作答 */
            hasExistingAnswers: true,
            /** 题目数据是否已加载完成（避免接口返回前渲染错位文案/布局造成闪烁） */
            risksLoaded: false
        };
    },
    computed: {
        isAnswered() {
            // 单选题：answer 不为空；多选题：answerArr 长度大于0
            return this.doQuestion.multselect === "0"
                ? !this.$util.isEmpty(this.answer)
                : !this.$util.isEmpty(this.answerArr) && this.answerArr.length > 0;
        },
        /** 路由带有已测评等级且题目存在历史作答时表示重新测评 */
        isReRiskAssessment() {
            const rl = this.$route.query.risklevel;
            return (
                rl !== undefined &&
                rl !== null &&
                String(rl).trim() !== "" &&
                this.hasExistingAnswers
            );
        }
    },
    watch: {
        answer(val) {
            if (this.isReRiskAssessment) {
                return;
            }
            // 监听答案更新数据
            if (val && val !== "") {
                const _this = this;
                if (
                    this.index < this.riskQuestions.length &&
                    val !== this.riskQuestions[this.index - 1].key
                ) {
                    // 自动跳到下一题
                    this.query = setTimeout(function () {
                        _this.questionRefresh(_this.index + 1);
                    }, 100);
                }
                this.$set(this.riskQuestions[this.index - 1], "key", val);
            }
        },
        answerArr(val) {
            if (this.isReRiskAssessment) {
                return;
            }
            if (val && val.length > 0) {
                this.$set(this.riskQuestions[this.index - 1], "key", val.join(","));
            }
        }
    },
    created() {
        this.firstriskdayflag = this.$route.query.firstriskdayflag || "1";
        this.assettype = this.$route.query.assettype || "*";
        this.getRisks();
        this.warningHtml = warningHtml.warningHtml14;
    },
    mounted() {
        this.needResultConfirm = this.$cache.getCompanyInfoParam("10102039") === "1";
    },
    methods: {
        async submitForm() {
            const _this = this;
            let _notDo = [];
            for (let _x in this.riskQuestions) {
                const _r = this.riskQuestions[_x].key;
                if (!_r) {
                    _notDo.push(Number(_x) + 1);
                }
            }
            if (!this.isReRiskAssessment && _notDo.length > 0) {
                this.firstRiskAnswerCardShowRed = true;
            }
            if (_notDo.length > 0) {
                this.msg = "您还有第" + _notDo.join(",") + "题(共" + _notDo.length + "题)没有回答!";
                this.btnMsg = "我已知晓";
                this.dialogVisible = true;
            } else {
                if (this.needResultConfirm) {
                    await this.predictRisk();
                    this.resultConfirmDialogVisible = true;
                } else {
                    // this.noticeDialogVisible = true;
                    this.makesureSubmit();
                }
            }
        },
        async predictRisk() {
            let { allResult, allPoint } = this.computePoint();
            const res = await userApi.combRiskGardeQuery({
                answer: allResult.substr(0, allResult.length - 1),
                papercode: this.riskQuestions[0].papercode
            });
            if (res.code == "0") {
                this.predictLevel = res.data.custrisk;
                this.predictLowriskflag = res.data.lowriskflag;
            }
        },
        computePoint() {
            const _this = this;
            let allResult = "";
            let allPoint = "";
            _this.noticeDialogVisible = false;
            for (let _x in this.riskQuestions) {
                const _r = this.riskQuestions[_x].key;
                if (_r) {
                    allResult += this.riskQuestions[_x].questioncode + ":" + _r + "|";
                    const _a = this.riskQuestions[_x].resultList;
                    let point = [];
                    for (let _z in _a) {
                        if (_r.indexOf(_a[_z].result) > -1) {
                            point.push(_a[_z].resultpoint);
                        }
                    }
                    allPoint += point.join(",") + "|";
                }
            }
            return { allPoint, allResult };
        },
        isLowestRiskLevel(riskLevel, lowriskflag) {
            return String(riskLevel) === "0" || String(lowriskflag) === "1";
        },
        getCurrentLowriskflag() {
            const user = this.$cache.getUser() || {};
            return this.$route.query.lowriskflag || user.lowriskflag || "";
        },
        getEffectiveRiskLevel(riskLevel, lowriskflag) {
            if (this.isLowestRiskLevel(riskLevel, lowriskflag)) {
                return 0;
            }
            const level = parseInt(riskLevel, 10);
            return Number.isNaN(level) ? -1 : level;
        },
        formatRiskLevel(riskLevel, lowriskflag) {
            if (this.isLowestRiskLevel(riskLevel, lowriskflag)) {
                return "最低风险等级(C0)";
            }
            if (this.$util.isEmpty(riskLevel)) {
                return "";
            }
            const level = parseInt(riskLevel, 10);
            const dictName = this.$cache.getDict("100017", riskLevel, false) || "";
            const cleanName = dictName.replace(/C\d+[-]?/, "").replace(/风险承受能力/g, "");
            return `${cleanName}(C${level})`;
        },
        async makesureSubmit() {
            const _this = this;
            let { allResult, allPoint } = this.computePoint();
            _this.noticeDialogVisible = false;
            try {
                if (this.data.risk) {
                    // this.firstriskdayflag = ""; // 临时代码
                    if (_this.firstriskdayflag !== "1") {
                        _this.combRiskGardeQuery(allResult, allPoint);
                    } else {
                        _this.combCustRiskService(allResult, allPoint);
                    }
                } else {
                    const res = await userApi.custKnowledgeRisk({
                        answer: allResult.substr(0, allResult.length - 1),
                        pointlist: allPoint.substr(0, allPoint.length - 1),
                        papercode: this.riskQuestions[0].papercode,
                        iscontinue: "1",
                        assettype: "*"
                    });
                    if (res.code == "0") {
                        _this.passflag = res.data.passflag;
                        if (_this.passflag === "1") {
                            // 投资者转换不支持校验交易密码
                            // if (_this.$cache.getPwdCheck("P2")) {
                            //     _this.ruleForm.tpasswd = "";
                            //     _this.tpasswdDialogVisible = true;
                            // } else {
                            //     _this.toProfessional();
                            // }
                            _this.toProfessional();
                        } else {
                            _this.msg = "您的投资者知识评测未达到要求";
                            _this.btnMsg = "重新评测";
                            _this.dialogVisible = true;
                        }
                    }
                }
            } catch (e) {
                this.$log.error(e);
            }
        },
        async combRiskGardeQuery(allResult, allPoint) {
            const _this = this;
            const res = await userApi.combRiskGardeQuery({
                answer: allResult.substr(0, allResult.length - 1),
                papercode: this.riskQuestions[0].papercode
            });
            if (res.code == "0") {
                const h = this.$createElement;
                const currentLowriskflag = this.getCurrentLowriskflag();
                if (
                    this.$route.query.risklevel &&
                    this.getEffectiveRiskLevel(res.data.custrisk, res.data.lowriskflag) >
                        this.getEffectiveRiskLevel(this.$route.query.risklevel, currentLowriskflag)
                ) {
                    this.$msgbox({
                        title: "提示",
                        message: h("div", [
                            "是否因最近一次填写错误，造成需在短时间内第二次重评风险测评问卷？",
                            h("br"),
                            `选择确定，此次重评生效，您的风险等级为：${this.formatRiskLevel(
                                res.data.custrisk,
                                res.data.lowriskflag
                            )}。`,
                            h("br"),
                            `选择取消，此次重评不生效，您的风险承受能力等级仍为：${this.formatRiskLevel(
                                this.$route.query.risklevel,
                                currentLowriskflag
                            )}。`
                        ]),
                        showCancelButton: true,
                        confirmButtonText: "确定",
                        type: "warning",
                        customClass: "info-check",
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                _this.combCustRiskService(allResult, allPoint);
                                done();
                            } else {
                                done();
                            }
                        }
                    });
                } else {
                    _this.combCustRiskService(allResult, allPoint);
                }
            }
        },
        async combCustRiskService(allResult, allPoint) {
            const _this = this;
            let assettype = this.$util.getParamValue("1000056");
            const res = await userApi.combCustRiskService({
                answer: allResult.substr(0, allResult.length - 1),
                pointlist: allPoint.substr(0, allPoint.length - 1),
                papercode: this.riskQuestions[0].papercode,
                iscontinue: "1",
                assettype: assettype.indexOf(_this.assettype) > -1 ? _this.assettype : "*"
            });
            if (res.code == "0") {
                _this.$cache.refreshUser(() => {
                    if (
                        _this.fn &&
                        this.$route.query.assettype != "3" &&
                        this.$route.query.assettype != "" &&
                        this.$route.query.assettype != "*"
                    ) {
                        _this.$emit("fn-back", false);
                    } else {
                        _this.$router.push({
                            name: _this.data.url,
                            query: {
                                iswarn: res.data.iswarn,
                                assettype: _this.assettype,
                                risklevel: res.data.custrisk
                            }
                        });
                    }
                });
            }
        },
        cancelConfirm() {
            var _this = this;
            _this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    _this.tpasswdDialogVisible = false;
                    _this.toProfessional();
                } else {
                    return false;
                }
            });
        },
        toProfessional() {
            this.ruleForm.tpasswd = "";
            this.$router.push({ name: this.data.url });
        },
        goToQuestion(n) {
            if (this.isReRiskAssessment) {
                const el = document.getElementById("risk-q-" + n);
                if (el) {
                    el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            } else {
                this.questionRefresh(n);
            }
        },
        /** 答题卡展示：多选按题目选项顺序（非勾选顺序） */
        answerCardKeyDisplay(question) {
            if (!question) {
                return "";
            }
            const raw = question.key;
            if (raw === undefined || raw === null || String(raw).trim() === "") {
                return "";
            }
            const str = String(raw).trim();
            if (question.multselect !== "1") {
                return str;
            }
            const order = (question.resultList || []).map((r) => String(r.result));
            const pos = (code) => {
                const i = order.indexOf(String(code).trim());
                return i === -1 ? 999 : i;
            };
            const parts = str
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean);
            parts.sort((a, b) => pos(a) - pos(b));
            /* 答题卡展示：多选不用英文逗号分隔，按选项顺序连续显示 */
            return parts.join("");
        },
        /** 答题卡：未作答格红框 */
        answerCardCellUnanswered(question) {
            if (!question) {
                return true;
            }
            const k = question.key;
            return k === undefined || k === null || String(k).trim() === "";
        },
        /** 初次风测：仅提交后标红；重新测评：未答即标红 */
        answerCardShowRedBorder(question) {
            if (!this.answerCardCellUnanswered(question)) {
                return false;
            }
            if (this.isReRiskAssessment) {
                return true;
            }
            return this.firstRiskAnswerCardShowRed;
        },
        flatMultiAnswer(qi) {
            const k = this.riskQuestions[qi] && this.riskQuestions[qi].key;
            return k ? String(k).split(",") : [];
        },
        setFlatMultiAnswer(qi, val) {
            const joined = val && val.length ? val.join(",") : "";
            this.$set(this.riskQuestions[qi], "key", joined);
        },
        // 刷新题目数据
        questionRefresh(val) {
            /* if(this.index === val){
                    return;
                } */
            clearTimeout(this.query);
            this.index = val;
            const _d = this.riskQuestions[this.index - 1];
            this.doQuestion = _d;
            this.answer = _d ? _d.key : "";
            this.answerArr = _d && _d.key && _d.key.length > 0 ? _d.key.split(",") : [];
        },
        // 获取题目信息
        async getRisks() {
            const _this = this;
            const papertype = this.data.risk ? "0" : "1";
            let assettype = this.$util.getParamValue("1000056");
            const res = await userApi.selectQuestionAndOption({
                invtp: this.$cache.getUser().invtp,
                status: "0",
                assettype: assettype.indexOf(_this.assettype) > -1 ? _this.assettype : "*",
                papertype: papertype
            });
            if (res.data) {
                // 整理题目数据格式
                for (let arr of res.data) {
                    if (
                        (arr.key === undefined || arr.key === null || arr.key === "") &&
                        arr.myanswer != null &&
                        arr.myanswer !== ""
                    ) {
                        arr.key = arr.myanswer;
                    }
                    _this.riskQuestions.push(arr);
                }
                // 只要有一个题目的 myanswer 为空，即视为首次测评
                const hasEmptyAnswer = res.data.some(
                    (item) => item.myanswer === "" || item.myanswer == null
                );
                if (hasEmptyAnswer) {
                    _this.hasExistingAnswers = false;
                }
            }
            _this.risksLoaded = true;
            if (!_this.isReRiskAssessment) {
                _this.questionRefresh(_this.index);
            }
        },
        resultCancel() {
            this.resultConfirmDialogVisible = false;
            this.predictLevel = "";
            this.predictLowriskflag = "";
        },
        resultConfirm() {
            this.resultCancel();
            this.makesureSubmit();
        }
    }
};
</script>
<style lang="scss">
.bizcomp-risk-header {
    display: flex;
    padding: 17px 0 21px;
    .risk-header-title {
        font-family: Source Han Sans CN;
        font-size: 20px;
        font-weight: 500;
        color: var(--color-text-primary);
    }
    .risk-header-text {
        font-family: Roboto;
        font-size: 16px;
        font-weight: normal;
        color: var(--color-text-accent);
        margin-top: 5px;
        margin-left: 8px;
    }
}
.comp-risk-ques {
    border: 1px solid var(--color-border-base);
    margin-bottom: 20px;
    .risk-test {
        .btn-prev {
            width: 120px;
            height: 36px;
            border-radius: 2px;
            background: var(--color-accent) !important;
            color: var(--color-primary) !important;
            border: 1px solid var(--color-accent);
            &:disabled {
                background: var(--color-divided) !important;
                border: 1px solid var(--color-divided);
                color: var(--color-text-white) !important;
            }
        }
        .btn-next {
            width: 120px;
            height: 36px;
            border-radius: 2px;
            background: var(--color-primary) !important;
            color: var(--color-text-white) !important;
            border: 1px solid var(--color-primary);
            margin-left: 30px;
            &:disabled {
                background: var(--color-divided) !important;
                border: 1px solid var(--color-divided);
            }
        }

        padding: 0 0 0 20px;
        .risk-tit {
            margin: 20px 0 10px;
            .risk-tit-box {
                background-color: var(--color-bg-container);
                border: 1px solid var(--color-divided);
                padding: 8px 10px;
                .risk-icon {
                    width: 42px;
                    height: 48px;
                    display: inline-block;
                    vertical-align: middle;
                    background: url($icon) -297px -122px no-repeat;
                    margin-right: 13px;
                }
                span {
                    display: inline-block;
                    vertical-align: middle;
                    line-height: 24px;
                    color: var(--color-text-accent);
                    width: 1076px;
                }
            }
        }
        .risk-ques {
            display: flex;
            &:not(.risk-ques--flat) {
                padding: 20px 20px 0 0;
                box-sizing: border-box;
                align-items: flex-start;
                > .risk-flat-layout {
                    width: 100%;
                    min-width: 0;
                }
            }
            .risk-header {
                .ques-tit {
                    display: block;
                    margin-top: 21px;
                    width: 100%;
                    padding-bottom: 10px;
                    color: var(--color-text-accent);
                    font-size: 14px;
                    &::after {
                        content: "";
                        display: table;
                        clear: both;
                    }
                    /* 与重新测评题干一致：浮动序号+单选，多行与序号左对齐 */
                    .ques-tit__progress {
                        float: left;
                        display: inline-flex;
                        align-items: baseline;
                        margin-right: 12px;
                        line-height: 1.2;
                    }
                    .ques-tit__current {
                        color: var(--color-text-primary);
                        font-weight: 500;
                        font-size: 28px;
                        line-height: 30px;
                    }
                    .ques-tit__total {
                        color: var(--color-text-accent);
                        font-size: $f16;
                        font-weight: normal;
                    }
                    .ques-multi {
                        float: left;
                        margin-right: 12px;
                        margin-top: 6.5px;
                        font-size: 11px;
                        line-height: 1;
                        padding: 3px 6px;
                        color: var(--color-primary);
                        background: #fff0f0;
                        border-radius: 2px;
                        &--multi {
                            background: #f6eada;
                            color: #64472d;
                        }
                    }
                    .ques-text {
                        display: block;
                        font-size: $f16;
                        line-height: 30px;
                        color: var(--color-text-primary);
                        font-weight: 500;
                        text-align: left;
                        word-break: break-word;
                    }
                }
                .ques-next {
                    margin-bottom: 20px;
                }
                .ques-box {
                    .ques-list {
                        /* 初次答题：选项区固定最小高度，避免选项少时「下一题」上下跳动 */
                        min-height: 260px;
                        box-sizing: border-box;
                        padding: 10px 0;
                        color: var(--color-text-regular);
                        font-size: $f16;
                        .el-radio-group,
                        .el-checkbox-group {
                            margin: 7px 0 10px 0;
                            .el-radio,
                            .el-checkbox {
                                display: block;
                                font-size: $f16;
                                line-height: 26px;
                            }
                            .el-radio + .el-radio,
                            .el-checkbox + .el-checkbox {
                                margin-left: 0;
                                margin-top: 9px;
                            }
                        }
                    }
                }
            }
            /* 多选 checkbox 标签默认字号小于单选 radio；与 .el-radio__label 对齐 */
            .risk-header .ques-box .ques-list,
            .risk-flat-item .ques-box .ques-list {
                .el-radio__label,
                .el-checkbox__label {
                    font-size: $f16 !important;
                    line-height: 26px !important;
                }
            }

            &.risk-ques--flat {
                flex-direction: column;
                align-items: stretch;
                /* 与答题盒子上、右侧各距 20px，答题卡不贴顶贴右 */
                padding: 20px 20px 0 0;
                box-sizing: border-box;
            }
            .risk-flat-layout {
                display: flex;
                align-items: flex-start;
                gap: 24px;
                width: 100%;
            }
            .risk-flat-main {
                flex: 1;
                min-width: 0;
            }
            .re-risk-tip {
                margin: 8px 0 16px;
                padding: 10px 12px;
                font-size: 14px;
                line-height: 22px;
                color: var(--color-text-accent);
                background: var(--color-bg-container);
                border: 1px solid var(--color-divided);
            }
            .risk-flat-list {
                width: 100%;
            }
            .risk-flat-item {
                margin-bottom: 8px;
                .ques-tit {
                    display: block;
                    margin-top: 21px;
                    width: 100%;
                    padding-bottom: 10px;
                    color: var(--color-text-accent);
                    font-size: 14px;
                    &::after {
                        content: "";
                        display: table;
                        clear: both;
                    }
                    .ques-tit__progress {
                        float: left;
                        display: inline-flex;
                        align-items: baseline;
                        margin-right: 12px;
                        line-height: 1.2;
                    }
                    .ques-tit__current {
                        color: var(--color-text-primary);
                        font-weight: 500;
                        font-size: 28px;
                        line-height: 30px;
                    }
                    .ques-tit__total {
                        color: var(--color-text-accent);
                        font-size: $f16;
                        font-weight: normal;
                    }
                    .ques-multi {
                        float: left;
                        margin-right: 12px;
                        margin-top: 6.5px;
                        font-size: 11px;
                        line-height: 1;
                        padding: 3px 6px;
                        color: var(--color-primary);
                        background: #fff0f0;
                        border-radius: 2px;
                        &--multi {
                            background: #f6eada;
                            color: #64472d;
                        }
                    }
                    .ques-text {
                        display: block;
                        font-size: $f16;
                        line-height: 30px;
                        color: var(--color-text-primary);
                        font-weight: 500;
                        text-align: left;
                        word-break: break-word;
                    }
                }
                .ques-box .ques-list {
                    padding: 10px 0;
                    color: var(--color-text-regular);
                    font-size: $f16;
                    .el-radio-group,
                    .el-checkbox-group {
                        margin: 7px 0 10px 0;
                        .el-radio,
                        .el-checkbox {
                            display: block;
                            font-size: $f16;
                            line-height: 26px;
                        }
                        .el-radio + .el-radio,
                        .el-checkbox + .el-checkbox {
                            margin-left: 0;
                            margin-top: 9px;
                        }
                    }
                }
            }
            /* 重新测评：右上角答题卡（sticky） */
            .answer-card-sidebar {
                position: sticky;
                top: 20px;
                flex: 0 0 280px;
                width: 280px;
                max-width: 100%;
                z-index: 2;
            }
            .answer-card-panel {
                background: #f8f8f8;
                box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.12);
                border-radius: 4px 4px 0px 0px;
                padding: 14px 12px 16px;
                box-sizing: border-box;
            }
            .answer-card-panel__title {
                text-align: center;
                font-size: 14px;
                font-weight: 500;
                color: var(--color-text-regular);
                margin-bottom: 12px;
            }
            .answer-card-panel__grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 8px;
                margin-bottom: 14px;
            }
            .answer-card-panel__cell {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: flex-start;
                min-height: 40px;
                padding: 6px 8px;
                margin: 0;
                font-size: 12px;
                line-height: 1.35;
                text-align: left;
                color: var(--color-text-primary);
                background: #fff;
                border: 1px solid transparent;
                border-radius: 4px;
                cursor: pointer;
                box-sizing: border-box;
                transition: box-shadow 0.15s ease;
                &:hover {
                    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
                }
                &--unanswered {
                    border-color: #cc4633;
                }
            }
            .answer-card-panel__cell-no {
                flex-shrink: 0;
                font-size: 14px;
                color: #666666;
            }
            .answer-card-panel__cell-ans {
                font-size: 14px;
                color: #666666;
                word-break: break-all;
            }
            .answer-card-panel__submit {
                width: 100%;
                height: 42px;
                margin: 0;
                padding: 0;
                font-size: 16px;
                font-weight: 500;
                color: #fff !important;
                background: #cc4633 !important;
                border: none !important;
                border-radius: 4px;
                &:hover,
                &:focus {
                    background: #b33d2c !important;
                    color: #fff !important;
                }
            }

            .agree-content {
                padding: 15px 20px;
                > label {
                    margin-right: 7px;
                }
                .notice-read {
                    cursor: pointer;
                }
            }
        }
    }

    .margin-left-40 {
        margin-left: 40px;
    }
}
.color-666 {
    color: var(--color-text-regular) !important;
}
</style>
